module.exports = __webpack_public_path__ + "img/information.3ea1feaf.svg";